<script setup lang="ts">
import SubscriptionTab from '@/components/account/SubscriptionTab.vue';

definePage({
  name: 'account-subscription',
});
</script>

<template>
  <div class="account-container p-6">
    <h2 class="text-2xl font-bold mb-6 text-gray-900">
      Subscription Settings
    </h2>

    <SubscriptionTab />
  </div>
</template>

<style scoped>
.account-container {
  max-width: 1200px;
  margin: 0 auto;
}
</style>
